import React from 'react';
import { usePricingContext } from '../context/PricingContext';
interface PriceDisplayProps {
  type?: 'current' | 'compare';
  className?: string;
  hideCurrency?: boolean;
}
export function PriceDisplay({
  type = 'current',
  className = '',
  hideCurrency = false
}: PriceDisplayProps) {
  const {
    currentPrice,
    comparePrice,
    loading,
    currencyCode
  } = usePricingContext();
  if (loading) {
    return <span className={className} style={{
      opacity: 0.4
    }} data-id="element-132">
        ...
      </span>;
  }
  const number = type === 'compare' ? comparePrice : currentPrice;
  if (hideCurrency) {
    return <span className={className} data-id="element-133">{number}</span>;
  }
  return <span className={className} style={{
    whiteSpace: 'nowrap',
    display: 'inline'
  }} data-id="element-134">
      {'$ '}
      {number}{' '}
      <span style={{
      fontWeight: 700,
      letterSpacing: '0.04em'
    }} data-id="element-135">
        {currencyCode}
      </span>
    </span>;
}
/** Standalone currency code label — kept for backward compatibility */
export function PriceCurrencyLabel({
  className = '',
  style
}: {
  className?: string;
  style?: React.CSSProperties;
}) {
  const {
    currencyCode,
    loading
  } = usePricingContext();
  if (loading) return null;
  return <span className={className} style={{
    fontWeight: 700,
    letterSpacing: '0.04em',
    display: 'block',
    ...style
  }} data-id="element-136">
      {currencyCode}
    </span>;
}